import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=353727c0&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"
import style0 from "./UserList.vue?vue&type=style&index=0&id=353727c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353727c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353727c0')) {
      api.createRecord('353727c0', component.options)
    } else {
      api.reload('353727c0', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=353727c0&scoped=true", function () {
      api.rerender('353727c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/UserList.vue"
export default component.exports